import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import { Camera, Sparkles, Printer } from "lucide-react";
import ImageSlider from "../ImageSlider";
import { LanguageContext } from "../../context/LanguageContext";
import no from "../../context/no";
import en from "../../context/en";

const STEP_ICONS = [Camera, Sparkles, Printer];

const ConceptCard = ({ Icon, stepNumber, title, text, delay = 0, isLast }) => (
  <Fade delay={delay} direction="right" triggerOnce className="h-full">
    <div
      className={`h-full w-full flex flex-col justify-center gap-3 px-6 py-6 md:px-8 md:py-5 ${
        !isLast ? "border-b border-main-dark/10" : ""
      }`}
    >
      <div className="flex items-center gap-3">
        <Icon
          className="h-5 w-5 shrink-0 text-main-dark"
          color="#000000"
          strokeWidth={1.5}
          aria-hidden="true"
        />
        <span className="font-heading text-xs font-bold tracking-widest text-main-dark/40">
          {String(stepNumber).padStart(2, "0")}
        </span>
        <h4 className="text-main-dark font-heading font-bold text-lg md:text-xl !text-main-dark">
          {title}
        </h4>
      </div>
      <p className="text-main-dark/75 font-copy leading-relaxed text-sm md:text-base">
        {text}
      </p>
    </div>
  </Fade>
);

function ConceptComponent() {
  const { language } = useContext(LanguageContext);
  const translations =
    language === "en" ? en.home.conceptText : no.home.conceptText;
  const ctaLabel =
    language === "no"
      ? no.home.button.moreAboutConcept
      : en.home.button.moreAboutConcept;

  const steps = [translations[1], translations[2], translations[3]];

  return (
    <div className="flex flex-col gap-6 md:flex-row md:gap-8">
      <div className="flex-auto md:max-w-[50%]">
        <Fade triggerOnce>
          <ImageSlider />
        </Fade>
      </div>

      <div className="flex-auto flex flex-col justify-center md:max-w-[50%]">
        <div className="flex flex-col [&>div]:flex-auto">
          {steps.map((step, index) => (
            <ConceptCard
              key={step.title}
              Icon={STEP_ICONS[index]}
              stepNumber={index + 1}
              title={step.title}
              text={step.text}
              delay={index * 120}
              isLast={index === steps.length - 1}
            />
          ))}
        </div>

        <div className="px-6 pt-6 pb-2 md:px-8 md:pt-8 flex justify-center md:justify-start">
          <Link to="/products" className="cta cta-dark">
            {ctaLabel}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ConceptComponent;
